import { Helpers } from '../../core';
const ENROLLMENT_KET_FIELDS = [
    'etr_instantinkeligible',
    'etr_subscription_kitid',
    'etr_subscription_cta',
    'etr_subscription_url',
    'etr_subscription_price',
    'ekit_catentryId',
    'ekit_pdpUrl',
];
/**
 * Build enrollment kit object from product
 * @param {*} product
 * @returns
 */
export const pickEnrollmentKit = product => {
    try {
        const { etr_subscription_cta, etr_subscription_url, eol } = product || {};
        if (!eol && (etr_subscription_cta || etr_subscription_url)) {
            return ENROLLMENT_KET_FIELDS.reduce(
                (r, field) => {
                    const value = product[field];
                    switch (field) {
                        case 'etr_instantinkeligible':
                            r.instantInkEligible = value === 'Yes';
                            break;
                        case 'etr_subscription_kitid':
                            r.kit = r.kit || {};
                            r.kit.sku = value;
                            break;
                        case 'etr_subscription_cta':
                            r.btnProps.children = value;
                            break;
                        case 'etr_subscription_url':
                            r.btnProps.to = value;
                            break;
                        case 'etr_subscription_price':
                            const [price, frequency] = (value || '').split(/[\s/|\/]/).filter(s => s != '');
                            if (typeof price === 'string') {
                                const regularPrice = Helpers.convertPriceToNumber(price);
                                r.price = {
                                    regularPrice,
                                    salePrice: regularPrice,
                                    customPrefix: 'Price',
                                    ...(frequency ? { translations: { salePriceSuffix: `/ ${frequency}` } } : {}),
                                    isSubscription: !!frequency,
                                };
                            }
                            break;
                        case 'ekit_pdpUrl':
                            r.kit = r.kit || {};
                            r.kit.learnMoreLink = value;
                            break;
                        case 'ekit_catentryId':
                            r.kit = r.kit || {};
                            r.kit.catEntryId = value;
                            break;
                    }
                    delete product[field];
                    return r;
                },
                { btnProps: {} },
            );
        }
    } catch (e) {
        console.log('Error parsing enrollment kit', e);
    }

    return null;
};

/**
 * Temporary helper function to show dual CTA for kit products. Remove when new design is implemented for all products
 * @param {*} productInitial
 * @returns
 */
export const showDualCtaForKit = productInitial => {
    try {
        const { enrollmentKit, topCategory } = productInitial || {};
        const { btnProps, kit } = enrollmentKit || {};
        const { to, children: ctaText } = btnProps || {};
        const category = topCategory?.toLowerCase();

        return (
            !enrollmentKit ||
            (!kit?.catEntryId &&
                to &&
                typeof ctaText === 'string' &&
                ctaText.toLowerCase().indexOf('subscribe') > -1 &&
                (category == 'printers' || category == 'laptops'))
        );
    } catch (e) {
        return !productInitial?.enrollmentKit;
    }
};
